import { cookieStorage } from '@/lib/cookie-storage';
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware';

interface IuseStoreModal {
    isOpen: boolean;
    currentStore: string | null;
    currentStoreId: string | null;
    onOpen: () => void;
    onClose: () => void;
    selectStore: (store: string) => void;
    selectStoreId: (store: string) => void;
}


export const useCompany = create<IuseStoreModal>()(
    persist(
        (set) => ({
            isOpen: false,
            currentStore: null,
            currentStoreId: null,
            onOpen: () => set({ isOpen: true }),
            onClose: () => set({ isOpen: false }),
            selectStore: (store: string) => set({ currentStore: store }),
            selectStoreId: (id: string) => set({ currentStoreId: id })
        }),
        {
            name: 'store-modal',
            storage: createJSONStorage(() => cookieStorage),
        }
    )
)